export const authUrl = () => {
  if (window.location.host === 'edge.copima.ma') {
    return 'https://core.copima.ma';
  }
  return 'http://51.161.33.219:7084';
};
export const ACCESS_TOKEN_STORAGE = 'token';
export const ACCESS_USER_STORAGE = 'user';
